import React, { createContext, useState } from "react";

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toastMessages, setToastMessages] = useState([]);

  const addToast = (message = {}, type = "info", duration = 5000, options = {}) => {
    const normalizedType = type === "error" ? "danger" : type;
    const toastId =
      message?.id ||
      `toast-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const safeDuration = Number.isFinite(Number(duration))
      ? Number(duration)
      : 5000;
    const persistent = Boolean(options?.persistent);

    const toastPayload = {
      ...message,
      id: toastId,
      variant: normalizedType,
      delay: safeDuration,
      autohide: persistent ? false : options?.autohide ?? true,
      html: Boolean(options?.html),
    };

    setToastMessages((prev) => [
      ...prev,
      toastPayload,
    ]);

    if (toastPayload.autohide) {
      setTimeout(() => removeToast(toastId), safeDuration);
    }
  };

  const removeToast = (id) => {
    setToastMessages((prev) => prev.filter((toast) => toast.id !== id));
  };

  const value = {
    toastMessages,
    addToast,
    removeToast,
  };

  return (
    <ToastContext.Provider value={value}>{children}</ToastContext.Provider>
  );
};
